/* eslint-disable camelcase */
import Honeybadger from '@honeybadger-io/js';
import { Host } from '../Host';
import { BuildVersion } from '../version';

const hb = Honeybadger.configure({
    apiKey: 'hbp_J1kUBtAo3twdIiN9aKUSHW6DsFuGeo2oqizA',
    environment: Host.env,
    enableUncaught: false,
    enableUnhandledRejection: false,
    revision: BuildVersion,
    breadcrumbsEnabled: {
        console: false,
        dom: false,
        navigation: true,
        network: true,
    }
});

const lastAction = {
    value: null as [string, number],
};

const lastError = {
    value: null as any,
};

// const instance: R = new R({
//     accessToken: '8167141c74234b87a3757effb902d324',
//     captureUncaught: false,
//     captureUnhandledRejections: false,
//     captureIp: 'anonymize',
//     environment: Host.env,
//     codeVersion: BuildVersion,
//     autoInstrument: {
//         log: false,
//     },
//     payload: {
//         client: {
//             javascript: {
//                 code_version: BuildVersion,
//                 environment: Host.env,
//                 source_map_enabled: true,
//             }
//         }
//     }
// });

const newErrorCheck = (err: Error) => {
    if (lastError?.value === err || lastError?.value?.cause === err) {
        return true;
    }
    lastError.value = err;
    return false;
};

const error = (name: string, err: Error, extra?: any) => {
    if (Host.env === 'local') return;
    try {
        if (Host.env === 'local') return;
        if (newErrorCheck(err)) return;
        hb.notify(err, name, {
            context: extra,
        });
    }
    catch (err2) {
        // Fail
    }
};

const unknownError = (err: Error, extra?: any) => {
    if (Host.env === 'local') return;
    try {
        if (newErrorCheck(err)) return;
        hb.notify(err, {
            context: extra,
        });
    }
    catch (err2) {
        // Fail
    }
};

const logAction = (name: string) => {

    // If action is the same as lastAction and within 50ms, drop

    const now = Date.now();
    const [lastName, lt] = lastAction.value ?? [];

    lastAction.value = [name, now];

    if (lastName === name && (now - lt) <= 50) {
        return;
    }

    hb.addBreadcrumb(name, {
        category: 'custom',
    });
};

export const Monitor = Object.freeze({ error, unknownError, logAction, });

window.addEventListener('error', e => {
    // Do this to allow other error handlers to run first
    setTimeout(() => Monitor.unknownError(e.error), 0);
});


